import React from 'react';
import type { Maybe } from '@soundxyz/utils';
import type { ActivityGroupWithDivider } from '@components/Feed/store';
import {
  FeedActivityTypePostFragmentDoc,
  getFragment,
  PostGroupItemFragmentDoc,
} from '@graphql/reactQuery';
import { PlaylistPost } from './PlaylistPost';
import { ReleasePost } from './ReleasePost';

export const TrendingPost = ({
  postFrag,
}: {
  postFrag: Maybe<Omit<ActivityGroupWithDivider, 'isSameDay'>>;
}) => {
  if (!postFrag) return null;
  if (postFrag.information?.__typename !== 'UserCreatedPostAggregate') return null;

  const { post: userPost } = getFragment(FeedActivityTypePostFragmentDoc, postFrag.information);
  const post = getFragment(PostGroupItemFragmentDoc, userPost);

  if (post?.__typename === 'ReleasePost') {
    return <ReleasePost post={post} />;
  }

  if (post?.__typename === 'PlaylistPost') {
    return <PlaylistPost post={post} />;
  }

  return null;
};
